import { createContext } from 'react';
import { HydrationManager } from './manager.mjs';

const HydrationContext = /*#__PURE__*/createContext(new HydrationManager());

export { HydrationContext };
